module.exports = __webpack_public_path__ + "static/media/qr1.e09e566b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qr1.png
// module id = 23
// module chunks = 0